 const serviceHeroDetails = {
    title : "Comprehensive Software",
    title_s:"Consulting Services",
    description : "We provide software, website, and mobile applications that cater to your specific needs, solve challenges, and align with your business objectives to help you grow your business fast; we provide services and solutions tailored to your needs.",
    btnTitle: "Tell us about your project ",
    details: [
        {
            title: "Project Delivered on Time",
            desc : "96%"
        },
        {
            title: "Starting Price",
            desc : "$9/hr"
        },   {
            title: "Retention Rate",
            desc : "92%"
        },
    ],
    link:"/contactus"

  }

   const servicePriceDetails = [
    {
        title:"Dedicated Team Model",
        price:"$80",
        desc :"Ideal for: Ongoing and Long term projects",
        lists :  [
            "Dedicated SPOC",
            "Dedicated Team",
            "Dedicated Developers",
            "Flexibility Scale Up/Down Team",
            "Complete Control Over Priority and Timeline"
        ],
        isRecommended : false

    },
    {
        title:"Time & Material",
        price:"$80",
        desc :"Ideal for: Projects with evolving requirements",
        lists :[
            "Dedicated SPOC",
            "Agile development",
            "Hourly based pricing",
            "Dedicated resource allocation",
            "Flexibility to change scope, timeline",
            "Fixed Costs"
        ],
        isRecommended : true
    },
    {
        title:"Fixed Costs",
        price:"$80",
        desc :"Ideal for: Projects with clear goals & defined scope",
        lists :[
            "Agile Price",
            "Fixed Timeline",
            "Dedicated SPOC",
            "Dedicated Team",
            "Milestone Based Payment",
            "Dedicated resource allocation"
        ],
        isRecommended : false
    },
]


const hireDetails = {
    title:"HIRE US",
    title_p: "Have You Project To Discuss?",
    desc:"We have a team, expertise, and capabilities to deliver your needs. Let's connect with our team and say 'Hi' to your Idea. We are here to implement them",
    btnTitle:"Let's Connect",
    link:"/contactus"

}

export {serviceHeroDetails,servicePriceDetails,hireDetails}